import BlankStamp from '@components/blank/BlankStamp';
import styled from '@emotion/styled';

import useAutoIssueCoupon from './hooks/useAutoIssueCoupon';
import useOnScrollCard from './hooks/useOnScrollCard';
import useStampCards from './hooks/useStampCards';
import StampCard from './StampCard';

function StampCards() {
    const stampCards = useStampCards();
    useAutoIssueCoupon(stampCards);
    const { onScroll, containerRef, onScrollEnd } = useOnScrollCard();
    if (!stampCards || stampCards.length === 0) {
        return (<BlankWrapper>
            <BlankStamp/>
        </BlankWrapper>);
    }
    return (
        <Container ref={containerRef}
            onScroll={onScroll}
            onScrollEnd={onScrollEnd} >
            {stampCards?.map((card) => (
                <StampCard card={card}
                    key={`${card.targetScope}-${card.shopId}-${card.shopGroupId}`} />
            ))}
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    gap: 8px;
    scroll-snap-type: x mandatory;
    scroll-snap-stop: always;
    overflow: auto;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    align-items: flex-start;
    &::-webkit-scrollbar {
        display: none;
    }
`;

const BlankWrapper = styled.div`
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export default StampCards;
